import request from '@/utils/request.ts'

// export const getdatalist = (params: any) =>
//   request({
//     url: '/api/getadminmanage',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getdatalist = (params: any) =>
  request({
    url: '/users/getUserInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getSideWaylist = (params: any) =>
  request({
    url: '/users/getSideWayUserInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getorginizlist = (params: any) =>
  request({
    url: '/users/getOrganInfoByID',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })


// export const adduser = (params: any) =>
//   request({
//     url: '/api/adminmanage',
//     method: 'post',
//     data: params
//   })
export const adduser = (params: any) =>
  request({
    url: '/users/insertUser',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getuserinfodata = (params: any) =>
//   request({
//     url: '/api/adminmanage/:id',
//     method: 'get',
//     params
//   })
export const getuserinfodata = (params: any) =>
  request({
    url: '/users/getUserInfoById',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const changestate = (params: any) =>
//   request({
//     url: '/api/adminmanage',
//     method: 'put',
//     data: params
//   })
export const changestate = (params: any) =>
  request({
    url: '/users/updateUserstate',
    method: 'put',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// export const getorglist = () =>
//   request({
//     url: '/api/getorgnazitionlist',
//     method: 'get',

//   })
// export const getorglist = (params: any) =>
//   request({
//     url: '/users/getOrganInfo',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })

export const getorglist = (params: any) =>
  request({
    url: '/organization/getOrganList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

export const checktissueishave = (data: any) =>
  request({
    url: '/organization/checkUserByOrgan',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })